export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc8f007f423d73b65c798da2889ec020c687db640&name=fetchTypeahead!'